<template>
  <div class="download">
    <banner title="联系我们" subtitle="CONTACT US" />
    <div class="download-section" v-loading="loading">
      <div class="container">
        <div class="contact-grid">
          <div class="contact-card" v-for="item in contactItems" :key="item.label">
            <span class="contact-icon">{{ item.short }}</span>
            <div>
              <h3>{{ item.label }}</h3>
              <p>{{ item.value }}</p>
            </div>
          </div>
        </div>

        <div class="cta">
          <h3>欢迎咨询合作</h3>
          <p>无人机航测 · 三维建模 · 行业巡检 · UTC 培训与地理信息解决方案</p>
          <a class="phone-btn" :href="'tel:' + phone">立即拨打 {{ phone }}</a>
        </div>

        <div class="qr-block">
          <img src="../assets/img/ercode.jpg" alt="微信二维码" />
          <div>
            <h4>关注微信公众号</h4>
            <p>扫码关注,获取最新项目动态、技术资讯与行业解决方案</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: { Banner },
  data() {
    return {
      loading: true,
      phone: "400-871-5117",
      contactItems: [
        { label: "服务热线", value: "400-871-5117", short: "电" },
        { label: "移动电话", value: "13907488371", short: "移" },
        { label: "传　　真", value: "0731-84220628", short: "传" },
        { label: "邮　　箱", value: "zhuxingyuan010@vip.com", short: "邮" },
        {
          label: "公司地址",
          value: "湖南省长沙市高新开发区岳麓西大道588号芯城科技园8栋501",
          short: "地"
        }
      ]
    };
  },
  mounted() {
    this.$http
      .get("DataDictionary")
      .then(response => {
        const map = {};
        (response.data || []).forEach(i => {
          if (i && i.Key) map[i.Key] = i.Content;
        });
        if (map.ContactPhone) {
          this.phone = map.ContactPhone;
          this.contactItems[0].value = map.ContactPhone;
        }
        if (map.ContactMobile) this.contactItems[1].value = map.ContactMobile;
        if (map.ContactFax) this.contactItems[2].value = map.ContactFax;
        if (map.ContactEmail) this.contactItems[3].value = map.ContactEmail;
        if (map.ContactAddress) this.contactItems[4].value = map.ContactAddress;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.download {
  width: 100%;
  background: $color-bg-2;
  padding-bottom: 60px;
}

.download-section {
  padding: 28px 0 0;
}

.contact-grid {
  display: grid;
  // minmax(0, 1fr) 锁死最小宽度为 0,避免某列内容超长把别的列压扁
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  margin-bottom: 24px;
}

.contact-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 22px 24px;
  border: 1px solid $color-border;
  background: #fff;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: $color-accent;
  }

  .contact-icon {
    width: 48px;
    height: 48px;
    background: $color-accent;
    color: #fff;
    font-size: 22px;
    font-weight: 600;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h3 {
    margin: 0;
    font-size: 13px;
    color: $color-text-3;
    font-weight: 500;
    letter-spacing: 1px;
  }

  p {
    margin: 6px 0 0;
    color: $color-text;
    font-size: 15px;
    line-height: 1.5;
    font-weight: 500;
  }
}

.cta {
  border: 1px solid $color-border;
  border-left: 6px solid $color-accent;
  padding: 30px 32px;
  margin-bottom: 24px;
  background: #fff;

  h3 {
    margin: 0;
    color: $color-text;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 1px;
  }

  p {
    margin: 10px 0 22px;
    color: $color-text-2;
    font-size: 14px;
    line-height: 1.7;
  }

  .phone-btn {
    display: inline-block;
    padding: 11px 32px;
    background: $color-accent;
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 2px;
    border: 1px solid $color-accent;
    transition: background 0.2s ease;

    &:hover {
      background: $color-accent-dark;
      border-color: $color-accent-dark;
      color: #fff;
    }
  }
}

.qr-block {
  display: flex;
  align-items: center;
  gap: 20px;
  border: 1px solid $color-border;
  padding: 22px 28px;
  background: #fff;
  margin-bottom: 24px;

  img {
    width: 110px;
    height: 110px;
    border: 1px solid $color-border-dark;
    padding: 4px;
    background: #fff;
    flex-shrink: 0;
  }

  h4 {
    margin: 0;
    font-size: 16px;
    color: $color-text;
    font-weight: 600;
  }

  p {
    margin: 8px 0 0;
    color: $color-text-2;
    font-size: 13px;
    line-height: 1.8;
    max-width: 540px;
  }
}

@media (max-width: 900px) {
  .contact-grid { grid-template-columns: 1fr; }
  .cta { padding: 24px 20px; }
  .cta h3 { font-size: 18px; }
  .qr-block { flex-direction: column; align-items: flex-start; text-align: left; }
}

@media (max-width: 640px) {
  .contact-card { padding: 16px; gap: 12px; }
  .contact-card .contact-icon { width: 40px; height: 40px; font-size: 18px; }
  .contact-card p { font-size: 14px; }
}
</style>
